module.exports = __webpack_public_path__ + "816fa7654b1595553d71f19d0f1bce77.png";